import { render, staticRenderFns } from "./GjwPagination.vue?vue&type=template&id=6c5d07bc&scoped=true&"
import script from "./GjwPagination.vue?vue&type=script&lang=js&"
export * from "./GjwPagination.vue?vue&type=script&lang=js&"
import style0 from "./GjwPagination.vue?vue&type=style&index=0&id=6c5d07bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5d07bc",
  null
  
)

export default component.exports